import React from 'react'

const Plans = () => {
  return (
    <div style={{ textAlign: 'center' }}>
        <br />
        <br />
        <br />
        <div className="container">
            <div className="container" style={{width:"90%",marginLeft:"50px"}}>
                <h1 className='planPage' style={{fontSize:"40px"}}>WANT TO BUILD YOUR OWN WORKOUT PLAN?</h1>
                <br />
                <h4 className='planPage' style={{fontSize:"20px",marginTop:"-10px ",color:"#54595F"}}>Customize your workout plan with over 3000 free exercises in Jefit Workout Plan Builder. And easily share <br/>with friends.</h4>
                <br />
                <button className="btnall" style={{marginTop:"-10px "}}>CREATE YOUR WORKOUT PLAN</button>
            </div>
        </div>
    </div>
  )
}

export default Plans